import { useAuth } from '@/contexts/AuthContext';
import { FileText, Briefcase, Upload, Users, Settings, Inbox } from 'lucide-react';
import { Link } from 'react-router-dom';

const CARDS = [
  { to: '/admin/content', icon: FileText, label: 'Page Content', desc: 'Edit homepage, about, services, and other page text' },
  { to: '/admin/jobs', icon: Briefcase, label: 'Job Openings', desc: 'Add, edit, or remove career listings' },
  { to: '/admin/applications', icon: Inbox, label: 'Applications', desc: 'Review applicants, download resumes, update status' },
  { to: '/admin/documents', icon: Upload, label: 'Documents', desc: 'Upload capability statements and PDFs' },
  { to: '/admin/settings', icon: Settings, label: 'Settings', desc: 'Update contact information and details' },
];

export default function AdminDashboard() {
  const { user } = useAuth();

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-1">Welcome back, {user?.name}</h1>
      <p className="text-sm text-[#666] mb-8">Manage your website content and settings</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CARDS.map((card) => (
          <Link key={card.to} to={card.to} className="bg-[#161616] border border-white/10 p-6 hover:border-[#F2B705]/30 transition-all group">
            <div className="flex items-center gap-3 mb-2">
              <card.icon size={20} className="text-[#F2B705]" />
              <h3 className="text-sm font-semibold text-white group-hover:text-[#F2B705] transition-colors">{card.label}</h3>
            </div>
            <p className="text-xs text-[#666]">{card.desc}</p>
          </Link>
        ))}
      </div>

      {user?.role === 'superadmin' && (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link to="/admin/users" className="bg-[#161616] border border-white/10 p-6 hover:border-[#F2B705]/30 transition-all group">
            <div className="flex items-center gap-3 mb-2">
              <Users size={20} className="text-[#F2B705]" />
              <h3 className="text-sm font-semibold text-white group-hover:text-[#F2B705] transition-colors">User Management</h3>
            </div>
            <p className="text-xs text-[#666]">Manage admin users and roles</p>
          </Link>
        </div>
      )}
    </div>
  );
}
